var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center",class:_vm.hasActionSlot() ? 'justify-content-between' : '',attrs:{"id":"header"}},[_vm._t("title"),_c('div',[_vm._t("action")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }